import { useState } from "react";
import { Box, Flex, HStack, Heading, Select, Text } from "@chakra-ui/react";
import GuestCounterChart from "./GuestCounterChart";

export const GuestCounterCard = ({ dayData, monthData }) => {
  const [filter, setFilter] = useState("monthly");

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  // Transform the data based on the selected filter (monthly or daily)
  const transformData = (data, isMonthly) => {
    if (!data || !data.analysis) {
      return {
        labels: [],
        datasets: [
          { label: "In", data: [], backgroundColor: "#0c6c9e", barThickness: 20 },
          {
            label: "Out",
            data: [],
            backgroundColor: "orange",
            barThickness: 20,
          },
          {
            label: "Pending",
            data: [],
            backgroundColor: "blue",
            barThickness: 20,
          },
        ],
      };
    }

    if (isMonthly) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const monthlyData = {
        labels: months,
        datasets: [
          {
            label: "In",
            data: Array(12).fill(0),
            backgroundColor: "#0c6c9e",
            barThickness: 20,
          },
          {
            label: "Out",
            data: Array(12).fill(0),
            backgroundColor: "orange",
            barThickness: 20,
          },
          {
            label: "Pending",
            data: Array(12).fill(0),
            backgroundColor: "blue",
            barThickness: 20,
          },
        ],
      };

      data.analysis.forEach((item) => {
        const monthIndex = item.month - 1; // Convert month number to index (0-based)
        if (item.status === "IN")
          monthlyData.datasets[0].data[monthIndex] = item.count;
        if (item.status === "OUT")
          monthlyData.datasets[1].data[monthIndex] = item.count;
        if (item.status === "PENDING")
          monthlyData.datasets[2].data[monthIndex] = item.count;
      });

      return monthlyData;
    }

    // Assuming dayData has similar structure but for days
    const dailyData = {
      labels: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      datasets: [
        {
          label: "In",
          data: Array(7).fill(0),
          backgroundColor: "#0c6c9e",
          barThickness: 20,
        },
        {
          label: "Out",
          data: Array(7).fill(0),
          backgroundColor: "orange",
          barThickness: 20,
        },
        {
          label: "Pending",
          data: Array(7).fill(0),
          backgroundColor: "blue",
          barThickness: 20,
        },
      ],
    };

    data.analysis.forEach((item) => {
      const dayIndex = item.day - 1; // Convert day number to index (0-based)
      if (item.status === "IN")
        dailyData.datasets[0].data[dayIndex] = item.count;
      if (item.status === "OUT")
        dailyData.datasets[1].data[dayIndex] = item.count;
      if (item.status === "PENDING")
        dailyData.datasets[2].data[dayIndex] = item.count;
    });

    return dailyData;
  };

  const chartData =
    filter === "monthly"
      ? transformData(monthData, true)
      : transformData(dayData, false);

  return (
    <Box
      bg={"#FFFFFF"}
      borderRadius="10px"
      boxShadow="0px 3px 6px #0000003B"
      p={"15px"}
      w={["100%", "100%", "48.5%"]}
    >
      <Flex
        justify={["space-between"]}
        w={"100%"}
        align={"center"}
        flexWrap={["wrap", "wrap", "nowrap"]}
      >
        <Heading fontSize={"18px"} color={"#000"}>
          Guest Counter Graph
        </Heading>
        <HStack>
          <Flex align={"center"}>
            <Box h="11px" w="16px" rounded={"sm"} bg={"#0c6c9e"} mr="10px"></Box>
            <Flex justify={"space-between"} w="100%">
              <Text color={"#000"}>{"In"}</Text>
            </Flex>
          </Flex>
          <Flex align={"center"}>
            <Box h="11px" w="15px" rounded={"sm"} bg={"orange"} mr="10px"></Box>
            <Flex justify={"space-between"} w="100%">
              <Text color={"#000"}>{"Out"}</Text>
            </Flex>
          </Flex>
          <Flex align={"center"}>
            <Box h="11px" w="15px" rounded={"sm"} bg={"blue"} mr="10px"></Box>
            <Flex justify={"space-between"} w="100%">
              <Text color={"#000"}>{"Pending"}</Text>
            </Flex>
          </Flex>
        </HStack>
        <Select
          value={filter}
          onChange={handleFilterChange}
          color={"#3C7B79"}
          borderColor={"#3C7B79"}
          w={"150px"}
        >
          <option value="monthly">Monthly</option>
          <option value="daily">Daily</option>
        </Select>
      </Flex>
      <GuestCounterChart data={chartData} />
    </Box>
  );
};

// import { Box, Flex, HStack, Heading, Select, Text } from "@chakra-ui/react";
// import React from "react";
// import GuestCounterChart from "./GuestCounterChart";

// export const GuestCounterCard = ({ data }) => {
//   return (
//     <Box
//       bg={"#FFFFFF"}
//       borderRadius="10px"
//       boxShadow="0px 3px 6px #0000003B"
//       p={"15px"}
//       w={["100%", "100%", "48.5%"]}
//     >
//       <Flex
//         justify={["space-between"]}
//         w={"100%"}
//         align={"center"}
//         flexWrap={["wrap", "wrap", "nowrap"]}
//       >
//         <Heading fontSize={"18px"} color={"#000"}>
//           Guest Counter Graph
//         </Heading>
//         <HStack>
//           <Flex align={"center"}>
//             <Box h="11px" w="16px" rounded={"sm"} bg={"#0c6c9e"} mr="10px"></Box>
//             <Flex justify={"space-between"} w="100%">
//               <Text color={"#000"}>{"In"}</Text>
//             </Flex>
//           </Flex>
//           <Flex align={"center"}>
//             <Box h="11px" w="15px" rounded={"sm"} bg={"orange"} mr="10px"></Box>
//             <Flex justify={"space-between"} w="100%">
//               <Text color={"#000"}>{"Out"}</Text>
//             </Flex>
//           </Flex>
//         </HStack>
//         <Select
//           placeholder="Monthly"
//           color={"#3C7B79"}
//           borderColor={"#3C7B79"}
//           w={"150px"}
//         >
//           <option value="monthly">Monthly</option>
//           <option value="daily">Daily</option>
//         </Select>
//       </Flex>
//       <GuestCounterChart data={data} />
//     </Box>
//   );
// };
